<div *ngIf="prikaziStranicu" clss="container-fluid">
  <h2 class="content-block">Ispis naljepnica LOT</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)"
        >
        </dx-date-box>
      </div>

      <div class="odabirDatuma" style="margin-right: 30px">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)"
        >
        </dx-date-box>
      </div>

      <!-- OVO JE ODABIR SKLADIŠTA SIROVINA, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <label [style]="{ 'margin-left': '30px' }">Skladište sirovina:</label>
        <dx-select-box
          displayExpr="sifrainaziv"
          [items]="skladistaSirovina"
          width="400"
          (onValueChanged)="onChangeSkladisteSirovina($event)"
          [style]="{ 'margin-left': '30px' }"
        >
        </dx-select-box>
      </div>

      <!-- OVO JE ZA PRAVLJENJE PDF-a, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <!-- <div class="odabirDatuma">
        <dx-button
          *ngIf="stavkeIzdatnicaLotSirovina.length > 0"
          (onClick)="pdfIzdatnicaLotSirovinaSkupno()"
          [style]="{ 'margin-left': '30px' }"
          >Izradi PDF</dx-button
        >
      </div> -->

      <!-- OVO JE ZA PRAVLJENJE PDF-a, ALI RADI CSS-a SE KLASA ZOVE ODABIR DATUMA -->
      <div class="odabirDatuma">
        <dx-check-box
          [value]="zavrseniNalozi"
          (onValueChanged)="onChangeZavrseniNalozi($event)"
          [style]="{ 'margin-left': '30px' }"
          text="Završeni nalog"
        ></dx-check-box>
      </div>
    </div>

    <div class="customTable dnevniPlan">
      <dx-data-grid
        [dataSource]="stavkeIzdatnicaLotSirovina"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        [showBorders]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0" style="padding-right: 30px">Dokumenti</h2>
            <p class="mt-0">Kliknite na dokument za prikaz detalja</p>
          </div>
        </div>

        <!-- <dxo-filter-row [visible]="true"></dxo-filter-row> -->
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="15"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[20, 30, 40]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="dv_sifra"
          caption="Dokument"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="do_broj"
          caption="Broj"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="do_datum"
          caption="Datum"
          width="fit-content"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="ar_sifra"
          caption="Artikl"
          width="fit-content"
          alignment="left"
        ></dxi-column>

        <dxi-column
          dataField="ar_lot"
          caption="LOT"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="ar_naziv"
          caption="Naziv artikla"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column
          dataField="ar_lotstanje"
          caption="Stanje"
          alignment="left"
          width="fit-content"
        ></dxi-column>

        <dxi-column cellTemplate="uredjivanje" width="55" alignment="left">
          <div *dxTemplate="let data of 'uredjivanje'">
            <dx-button
              [disabled]="pravaZaTrenutniPogled != 2"
              icon="print"
              hint="Ispis QR kodova"
              (onClick)="pdfIzdatnicaLotSirovinaPojedinacno(data)"
            >
            </dx-button>
          </div>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
